import { Box, Grid, Skeleton } from '@factorialco/deprecated-design-system'

export const ApplicationPhasesSelectorSkeleton = () => {
  return (
    <Grid variant="fixed">
      {[...Array(4)].map((_, index) => (
        <Box
          gridColSpan={{ xxs: 1, xs: 6 }}
          key={index}
          component="li"
          alignItems="center"
          paddingRight="s12"
          paddingY="s0"
        >
          <Box alignItems="center" gap="s8" flexDirection="row" width="full">
            <Skeleton height="s24" width="s24" />
            <Skeleton height="s16" width="s120" />
          </Box>
        </Box>
      ))}
    </Grid>
  )
}
